import moment from "moment-timezone";
import _ from "lodash";
import colors from "vuetify/lib/util/colors";
import { State2Way } from "@/decorators";
import { Apollo } from "@/decorators";

import GENERAL_LEDGER_DETAIL_QUERY from "../graphql/GeneralLedgerDetail.gql";
import GENERAL_LEDGER_BNC_DETAIL_QUERY from "../graphql/GeneralLedgerBNCDetail.gql";
import CREATE_LETTERING from "../graphql/reconciliation/CreateLettering.gql";
import LINK_BANKTRANSACTION_AND_DOCUMENT from "../graphql/bankTransaction/LinkBankTransactionAndDocument.gql";
import DELETE_RECONCILIATION from "../graphql/reconciliation/DeleteReconciliation.gql";
import SWITCH_ACCOUNTABLE_ACCOUNT from "../graphql/accountableAccount/SwitchAccountableAccount.gql";
import VALIDATE_RECONCILIATION from "../graphql/reconciliation/ValidateReconciliation.gql";

import { isAccountingZero, mathFix } from "../services/mathServices";
import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";
import { getXMLString } from "../../../backend/src/common/services/string.services";
import { createCompany } from "../services/companyServices";
import { updateBankTransactionAccountableAccount } from "../services/bankTransactionServices";
import { User } from "../store/store";
import { ComponentBase } from "./ComponentBase";
import {
    isInsideAccountingClosing,
    isInsideClosedAccountingPeriod,
} from "../services/accountingPeriods";
import { Component, Emit } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["openReconciliation", "refresh"],
})
export class AccountableAccountBalanceDetailBase extends ComponentBase {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) accountingPeriodId: string;
    @Prop({ default: "" }) accountingClosingId: string;
    @Prop({ default: null }) accountableAccountInfo: any;
    @Prop({ default: "" }) selectedAccountingLineId: any;
    @Prop({ default: false }) notReconciliated: boolean;
    // @Prop({ default: false }) withoutLettering:boolean;
    @Prop({ default: false }) toValidateOnly: boolean;
    @Prop({ default: "ALL" }) transactionType: string;
    @Prop({ default: false }) withoutBank: boolean;
    @Prop({ default: false }) withoutDocument: boolean;
    @Prop({ default: null }) inAccountingTransactions: any;
    @Prop({ default: "openPoints" }) mode: string;
    @Prop({ default: "" }) search: string;
    @Prop({ default: null }) startDate;
    @Prop({ default: null }) endDate;
    // @Prop({ default: false }) isFromAdmin: boolean;
    @Prop({ default: "70vh" }) tableHeight;
    @Prop({ default: false }) thirdPartyMode: boolean;

    @State2Way("updateAccountableAccountTable", "accountableAccountTable")
    accountableAccountTable;

    // letteringElligibleAAs = ["401000", "411000", "421000"]

    withDeltaAAs = ["401000", "411000", "442100", "431000", "433000", "433500", "433600"];

    dialogSelectCompany = false;

    userDialog = false;

    subSelectedAccountableAccounts = [];

    // subAccountableAccountDialogSelect = false

    subAccountableAccountTitle = "";

    refreshCalled = false;

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
    }

    get isIncomingOutgoingPayment() {
        if (
            this.selectedCompany.profile &&
            this.selectedCompany.profile.accountingType === "INCOMING_OUTGOING_PAYMENT"
        ) {
            return true;
        }
        return false;
    }

    get isBNC() {
        return this.selectedCompany?.taxSystem === "BNC";
    }

    showAccountingTransactionDialog = false;
    showDocument = false;
    documentId = "";

    showReconciliation = false;
    reconciliationId = null;
    bankTransactionId = null;

    selectedAccountingTransactionIndex = -1;

    tags = [];
    tag = "all";

    lastSelected = null;

    alertNonAuthorizedDatesDialog = false;

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        // if(this.isFromAdmin) {
        //     return false
        // }
        return this.currentUser.isAccountingUser;
    }

    get outStandingMode() {
        return this.mode?.startsWith("outstanding");
    }

    get openPointMode() {
        return this.mode === "openPoints";
        // if (this.outStandingMode) {
        //     return false
        // }
        // return this.isAccountingUser
    }

    formatDate(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }

    //
    // selection
    //

    selectedAccountingTransactionKeys = [];

    get selectedAccountingTransactionCount() {
        return this.selectedAccountingTransactionKeys.length;
    }

    get selectedAccountingTransactions() {
        return this.accountingTransactions.filter((at) =>
            this.selectedAccountingTransactionKeys.includes(at.index),
        );
    }

    get selectedAccountingTransactionForTagguing() {
        return this.selectedAccountingTransactions.filter((at) => !!at.accountingLineId);
    }

    get fullSelectedAccountingTransactions() {
        const selectedAccountingTransactions = [...this.selectedAccountingTransactions];
        for (const selectedAccountingTransaction of this.selectedAccountingTransactions) {
            if (selectedAccountingTransaction.lettering) {
                const letterings = this.workingAccountingTransactions.filter(
                    (x) => x.lettering === selectedAccountingTransaction.lettering,
                );
                for (const at of letterings) {
                    if (!selectedAccountingTransactions.find((sat) => sat.index === at.index)) {
                        selectedAccountingTransactions.push(at);
                    }
                }
            }
        }
        return selectedAccountingTransactions;
    }

    get enableThirdPartyCompanyModification() {
        if (this.accountableAccountInfo && this.accountableAccountInfo.name) {
            const dbAA = this.accountableAccountTable.accountableAccounts.find(
                (aa) => this.accountableAccountInfo.name,
            );
            if (dbAA && dbAA.thirdPartyCompany) {
                return true;
            }
        }
        return false;
    }

    get enableUserModification() {
        if (this.accountableAccountInfo && this.accountableAccountInfo.name) {
            const dbAA = this.accountableAccountTable.accountableAccounts.find(
                (aa) => this.accountableAccountInfo.name,
            );
            if (dbAA && dbAA.user) {
                return true;
            }
        }
        return false;
    }

    getItemLog(item) {
        let log = "";
        if (item.bankAccountName) {
            log = item.bankAccountName;
        } else if (!this.isAccountingUser && item.object.fromDocumentId) {
            if (this.accountableAccountInfo.name.startsWith("401")) {
                log = this.$t("accountingItem.type.PURCHASE_INVOICE").toString();
            } else if (this.accountableAccountInfo.name.startsWith("411")) {
                log = this.$t("accountingItem.type.SALES_INVOICE").toString();
            } else if (this.accountableAccountInfo.name.startsWith("421")) {
                log = this.$t("accountingItem.type.PAY_SLIP").toString();
            }
        } else {
            log = this.$t("accountingItem.type." + item.log).toString();
        }
        if (item.fromCarryForward) {
            log += " (AN)";
        }
        return log;
    }

    isCheckable(item) {
        if (this.accountableAccountInfo && this.accountableAccountInfo.name) {
            if (!item.object || !item.object.type /*|| item.object.accountingItemImport*/) {
                return false;
            }
            if (
                item.object.type !== "bankTransaction" &&
                item.object.type !== "document" &&
                item.object.type !== "zTillReceipt"
            ) {
                return false;
            }
            if (item.object.accountingLinesLocked) {
                return true;
            }
            if (!!this.accountableAccountReplacementRule) {
                if (
                    this.accountableAccountReplacementRule.fromAccountingImportOnly &&
                    !item.object.accountingItemImport
                ) {
                    return false;
                }
                return true;
            }
            if (this.enableThirdPartyCompanyModification) {
                return true;
            }
            if (this.enableUserModification) {
                return true;
            }
        }
        return false;
    }

    get filteredSelectedAccountingTransactionsId() {
        const accountingLines = [];
        for (const accountingTransaction of this.fullSelectedAccountingTransactions) {
            if (!this.isCheckable(accountingTransaction)) {
                continue;
            }
            if (accountingTransaction.accountingLineId) {
                accountingLines.push(accountingTransaction.accountingLineId);
            }
        }
        return accountingLines;
    }

    //
    // 471 without accountingLineId only
    //
    get filteredSelectedBankTransaction() {
        const bankTransactions = [];
        for (const accountingTransaction of this.fullSelectedAccountingTransactions) {
            if (
                !accountingTransaction.accountingLineId &&
                this.isCheckable(accountingTransaction) &&
                accountingTransaction.object?.type === "bankTransaction"
            ) {
                bankTransactions.push(accountingTransaction);
            }
        }
        return bankTransactions;
    }

    compute(accountingTransactions) {}

    afterCompute(accountingTransactions) {
        for (const index in accountingTransactions) {
            accountingTransactions[index].index = parseInt(index);
        }
    }

    @Apollo({
        query() {
            return !this.accountableAccountInfo.bnc
                ? GENERAL_LEDGER_DETAIL_QUERY
                : GENERAL_LEDGER_BNC_DETAIL_QUERY;
        },
        fetchPolicy: "network-only",
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                accountingClosingId: this.accountingClosingId || undefined,
                accountableAccountName: !this.accountableAccountInfo.bnc
                    ? this.accountableAccountInfo.name
                    : undefined,
                thirdPartyCompanyId: !this.accountableAccountInfo.bnc
                    ? this.accountableAccountInfo.thirdPartyCompanyId
                    : undefined,
                thirdPartyCompanyName: !this.accountableAccountInfo.bnc
                    ? this.accountableAccountInfo.thirdPartyCompanyName
                    : undefined,
                userId: !this.accountableAccountInfo.bnc
                    ? this.accountableAccountInfo.userId
                    : undefined,
                bankAccountType: !this.accountableAccountInfo.bnc
                    ? this.accountableAccountInfo.bankAccountType
                    : undefined,
                bankAccountName: !this.accountableAccountInfo.bnc
                    ? this.accountableAccountInfo.bankAccountName
                    : undefined,
                notReconciliated: this.notReconciliated || undefined,
                withAccountingChat: this.mode === "openPoints",
                withMails: this.outStandingMode,
                computeStillOwe: this.outStandingMode,
                startDate:
                    this.startDate && moment(this.startDate).isValid() ? this.startDate : undefined,
                endDate: this.endDate && moment(this.endDate).isValid() ? this.endDate : undefined,
                incomingOutgoingPayment:
                    this.isIncomingOutgoingPayment &&
                    (this.mode === "openPoints" || this.outStandingMode)
                        ? true
                        : false,
                // excludeLog:"VAT"
            };
        },
        skip() {
            // return !this.companyId || (!this.accountingPeriodId && !this.withoutLettering) || !this.accountableAccountInfo || !this.accountableAccountInfo.name

            // // don't works with !!this.inAccountingTransactions
            return (
                (this.inAccountingTransactions && this.inAccountingTransactions.length) ||
                !this.companyId ||
                !this.accountableAccountInfo ||
                (!this.accountableAccountInfo.bnc && !this.accountableAccountInfo.name)
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                const detail = data.generalLedgerDetail || data.generalLedgerBNCDetail;
                if (detail && detail.detail) {
                    if (detail && detail.detail.length && detail.detail[0].index !== undefined) {
                        return;
                    }
                    this.selectedAccountingTransactionKeys = [];
                    this.tags = [];
                    this.tag = "all";
                    this.compute(detail.detail);
                    this.workingAccountingTransactions = detail.detail;
                    // this.onSelectedAccountingLineIdChanged()
                    for (const at of this.workingAccountingTransactions) {
                        if (at.tags) {
                            for (const tag of at.tags) {
                                if (!this.tags.find((t) => t.id === tag.id)) {
                                    this.tags.push(tag);
                                }
                            }
                        }
                    }
                    if (this.tags.length) {
                        this.tags.splice(0, 0, {
                            id: "none",
                            name: "Sans étiquette",
                        });
                        this.tags.splice(0, 0, {
                            id: "all",
                            name: "Toutes les lignes",
                        });
                    }
                } else {
                    this.selectedAccountingTransactionKeys = [];
                    this.tags = [];
                    this.tag = "all";
                    this.workingAccountingTransactions = [];
                }

                this.emitQueryDone({
                    item: this.accountableAccountInfo,
                    aaName: this.accountableAccountInfo.name || undefined,
                    totalDebit: this.totalDebit,
                    totalCredit: this.totalCredit,
                    totalBalance: this.totalBalance,
                    queryLength: this.workingAccountingTransactions.length,
                });
            }
        },
    })
    workingAccountingTransactions = [];

    @Emit("query-done")
    emitQueryDone(data) {
        return data;
    }

    refresh() {
        if (this.inAccountingTransactions?.length) {
            this.refreshFather();
            return;
        } else if (this.$apollo.queries && this.$apollo.queries.workingAccountingTransactions) {
            this.refreshCalled = true;
            this.$apollo.queries.workingAccountingTransactions.refetch();
        } else {
            debugger;
        }
        this.refreshFather();
    }

    @Emit("refresh")
    refreshFather() {
        return;
    }

    close() {
        debugger;
    }

    get accountingTransactions(): AccountingTransaction[] {
        if (
            /*!this.withoutLettering &&*/ !this.toValidateOnly &&
            this.transactionType === "ALL" &&
            this.tag === "all" &&
            !this.search
        ) {
            return this.workingAccountingTransactions;
        }
        const ats = [];
        let balance = 0.0;
        const search = this.search ? this.accountableAccountInfo.search.toLowerCase() : undefined;
        for (const wat of this.workingAccountingTransactions) {
            // if (this.withoutLettering && wat.lettering && !wat.letteringAfterPeriod) {
            //     continue
            // }
            if (this.toValidateOnly && !wat.reconciliationToValidate) {
                continue;
            }
            if (this.tag === "none" && wat?.tags?.length) {
                continue;
            }
            if (
                this.tag !== "all" &&
                this.tag !== "none" &&
                (!wat.tags || !wat.tags.find((t) => t.id === this.tag))
            ) {
                continue;
            }
            if (search) {
                if (wat.wording.toLowerCase().indexOf(search) === -1) {
                    if (
                        !wat.invoiceNumber ||
                        wat.invoiceNumber.toLowerCase().indexOf(search) === -1
                    ) {
                        if (
                            !(Math.abs(wat.credit) + "").startsWith(search) &&
                            !(Math.abs(wat.debit) + "").startsWith(search)
                        ) {
                            continue;
                        }
                    }
                }
            }
            let amountSigned = wat.debit - wat.credit;
            if (this.transactionType === "income") {
                if (wat.object && wat.object.type === "bankTransaction") {
                    if (amountSigned > 0) continue;
                } else {
                    if (amountSigned < 0) continue;
                }
            } else if (this.transactionType === "outcome") {
                if (wat.object && wat.object.type === "bankTransaction") {
                    if (amountSigned < 0) continue;
                } else {
                    if (amountSigned > 0) continue;
                }
            }
            ats.push(wat);
            balance += amountSigned;
            // wat.wlBalance = balance
        }
        return ats;
    }

    getColor(amount) {
        return amount < 0 ? "color:red;" : "";
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    getAccountingTransactionBalance(accountingTransaction) {
        // const balance = this.withoutLettering ? accountingTransaction.wlBalance : accountingTransaction.balance
        return this.newCommonFormatCurrency(accountingTransaction.balance, undefined);
    }

    accountingTransactionStyle(accountingTransaction) {
        let style = "";
        if (accountingTransaction && accountingTransaction.object) {
            style = "cursor:pointer;";
            if (accountingTransaction.object.error) {
                style += `background-color: ${colors.red.accent1};`;
            }
        }
        return style;
    }

    getLetteringColor(accountingTransaction) {
        if (!accountingTransaction.lettering) {
            return "";
        }
        if (accountingTransaction.letteringDate && accountingTransaction.letteringAfterPeriod) {
            return "color:orange;";
        }
        return "";
    }

    isBankTransactionWaitingClientResponse(accountingTransaction) {
        if (
            accountingTransaction.object.type === "bankTransaction" &&
            accountingTransaction.chat &&
            accountingTransaction.chat.lastMessage &&
            accountingTransaction.chat.lastMessage.sender.company &&
            accountingTransaction.chat.lastMessage.sender.company.accountingFirm
        ) {
            return true;
        }
    }

    openReconciliation(data) {
        // this.$emit("openReconciliation", data)
        if (data) {
            if (data.documentId) {
                this.documentId = data.documentId;
                this.reconciliationId = "";
                this.bankTransactionId = "";

                this.showDocument = false;
                this.showReconciliation = true;
                this.showAccountingTransactionDialog = true;
            }
        }
    }

    openAccountingTransaction(accountingTransaction, reconciliationId: string = undefined) {
        console.log("click", accountingTransaction);
        if (accountingTransaction.object) {
            if (
                accountingTransaction.object.type === "document" ||
                accountingTransaction.object.fromDocumentId
            ) {
                if (reconciliationId || accountingTransaction.object.id) {
                    this.selectedAccountingTransactionIndex = this.accountingTransactions.findIndex(
                        (at) => at === accountingTransaction,
                    );
                    if (!reconciliationId) {
                        if (accountingTransaction.object.type === "document") {
                            this.documentId =
                                !this.isAccountingUser &&
                                accountingTransaction.object.fromDocumentId
                                    ? accountingTransaction.object.fromDocumentId
                                    : accountingTransaction.object.id;
                        } else if (accountingTransaction.object.fromDocumentId) {
                            this.documentId = accountingTransaction.object.fromDocumentId;
                        }

                        // this.documentId = (!this.isAccountingUser && accountingTransaction.object.fromDocumentId) ? accountingTransaction.object.fromDocumentId : accountingTransaction.object.id
                        if (this.documentId) {
                            this.reconciliationId = "";
                            this.bankTransactionId = "";

                            this.showDocument = true;
                            this.showReconciliation = false;
                        }
                    } else {
                        this.documentId = "";
                        this.bankTransactionId = "";
                        this.reconciliationId = reconciliationId;

                        this.showDocument = false;
                        this.showReconciliation = true;
                    }
                    this.showAccountingTransactionDialog = true;
                }
            } else if (accountingTransaction.object.type === "bankTransaction") {
                if (this.isAccountingUser) {
                    if (accountingTransaction.reconciliationId || accountingTransaction.object.id) {
                        if (accountingTransaction.reconciliationId) {
                            this.documentId = "";
                            this.bankTransactionId = "";
                            this.reconciliationId = accountingTransaction.reconciliationId;
                        } else {
                            this.documentId = "";
                            this.bankTransactionId = accountingTransaction.object.id;
                            this.reconciliationId = "";
                        }
                        this.showDocument = false;
                        this.showReconciliation = true;
                        this.showAccountingTransactionDialog = true;
                        this.selectedAccountingTransactionIndex =
                            this.accountingTransactions.findIndex(
                                (at) => at === accountingTransaction,
                            );
                    }
                } else if (this.isBankTransactionWaitingClientResponse(accountingTransaction)) {
                    if (accountingTransaction.object.id) {
                        this.emitBankTransactionSelected(accountingTransaction.object.id);
                    }
                }
            } else {
                this.showReconciliation = false;
                this.showDocument = false;
                this.showAccountingTransactionDialog = false;
                this.selectedAccountingTransactionIndex = this.accountingTransactions.findIndex(
                    (at) => at === accountingTransaction,
                );
            }
        }
    }

    @Emit("bankTransactionSelected")
    emitBankTransactionSelected(data) {
        return data;
    }

    get totalDebit() {
        let total = 0.0;
        for (const at of this.accountingTransactions) {
            // total += Math.round(at.debit * 100) / 100; // total += at.debit  // Number(this.newCommonFormatCurrency(at.debit, undefined) )
            total += at.debit;
        }
        return total;
    }

    get totalCredit() {
        let total = 0.0;
        for (const at of this.accountingTransactions) {
            // total += Math.round(at.credit * 100) / 100; // total += at.credit  // Number(this.newCommonFormatCurrency(at.credit, undefined) )
            total += at.credit;
        }
        return total;
    }

    get totalBalance() {
        return this.totalDebit - this.totalCredit;
    }

    get loading() {
        if (this.$apollo.queries.workingAccountingTransactions) {
            return this.$apollo.queries.workingAccountingTransactions.loading;
        }
        return false;
    }

    //
    // lettering
    //

    delta = null;

    letteringLoading: boolean = false;
    letteringDialog: boolean = false;

    //  @Apollo({
    //     query() {
    //         return ACCOUNTABLE_ACCOUNTS_QUERY;
    //     },
    //     variables() {
    //         return {
    //             companyId: this.companyId
    //         };
    //     },
    //     skip() {
    //         return !this.letteringDialog
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         if (!loading) {
    //             if (data && data.accountableAccounts) {
    //                 this.accountableAccounts = data.accountableAccounts //data.accountableAccounts.filter(aa => aa.name.length === 6)
    //             } else {
    //                 this.accountableAccounts = []
    //                 console.error("AccountableAccountVue data pb");
    //             }
    //         }
    //     }
    // })
    // accountableAccounts: Array<any> = [];
    get accountableAccounts() {
        if (this.accountableAccountTable.accountableAccounts) {
            return this.accountableAccountTable.accountableAccounts.filter(
                (aa) => aa.name.length >= 6,
            );
        }
        return [];
    }

    // ----------
    // lettering
    // ---------

    get letteringHeaders() {
        const result = [
            { text: "Selection", value: "letteringSelect", sortable: false, align: "center" },
            { text: "Libellé", value: "wording", sortable: false, align: "left" },
            { text: "Montant", value: "amountSigned", sortable: false, align: "right" },
            { text: "Lettrage", value: "letteringAmountSigned", sortable: false, align: "right" },
        ];
        // // if(this.atLeastOneStillOwe) {
        // //     result.push( { text: "Restant dû estimé", value: "amountSigned", sortable: false,  align: "right" })
        // // }
        // result.push( { text: "Montant Personnalisé", value: "personalisedAmountSigned", sortable: false,  align: "center" } )
        return result;
    }

    get enableLettering() {
        if (this.accountableAccountInfo.bnc) return true;
        if (!this.accountableAccountInfo?.name) return false;

        const dbAA = this.accountableAccountTable.accountableAccounts.find(
            (aa) => aa.name === this.accountableAccountInfo.name,
        );
        return dbAA?.lettering;
    }

    get authorizedLetteringDeltaAmount() {
        return 1e20;
        // if (!this.accountableAccountInfo) return 0.0
        // if (this.withDeltaAAs.indexOf(this.accountableAccountInfo.name) === -1) {
        //     return 0.0
        // }
        // return 2.0
    }

    get letteringSelected() {
        const letteringSelected = [];
        if (this.enableLettering) {
            if (this.selectedAccountingTransactions.length) {
                for (const sat of this.selectedAccountingTransactions) {
                    if (sat.lettering && !sat.reconciliationToValidate) {
                        return [];
                    }
                    const lat = _.cloneDeep(sat);
                    lat.letteringData = {
                        amountSigned: lat.debit - lat.credit,
                        select: true,
                    };
                    letteringSelected.push(lat);
                }

                const positives = [],
                    negatives = [];
                let positiveAmount = 0,
                    negativeAmount = 0;
                for (const at of letteringSelected) {
                    const amountSigned = at.debit - at.credit;
                    if (amountSigned > 0) {
                        positives.push(at);
                        positiveAmount += amountSigned;
                    } else {
                        negatives.push(at);
                        negativeAmount += amountSigned;
                    }
                }
                if (-negativeAmount > positiveAmount) {
                    for (const pat of positives) {
                        pat.letteringData.amountSigned = pat.debit - pat.credit;
                        pat.letteringData.select = true;
                    }
                    for (const nat of negatives) {
                        nat.letteringData.amountSigned = 0;
                        nat.letteringData.select = false;
                    }
                    let amountSigned = 0;
                    for (const nat of negatives) {
                        const natAmountSigned = nat.debit - nat.credit;
                        const difference = -(amountSigned + natAmountSigned) - positiveAmount;
                        if (difference <= 0) {
                            nat.letteringData.select = true;
                            nat.letteringData.amountSigned = natAmountSigned;
                            amountSigned += natAmountSigned;
                            if (difference === 0) {
                                break;
                            }
                        } else {
                            nat.letteringData.select = true;
                            nat.letteringData.amountSigned = natAmountSigned + difference;
                        }
                    }
                } else {
                    for (const nat of negatives) {
                        nat.letteringData.amountSigned = nat.debit - nat.credit;
                        nat.letteringData.select = true;
                    }
                    for (const pat of positives) {
                        pat.letteringData.amountSigned = 0;
                        pat.letteringData.select = false;
                    }
                    let amountSigned = 0;
                    for (const pat of positives) {
                        const patAmountSigned = pat.debit - pat.credit;
                        const difference = amountSigned + patAmountSigned + negativeAmount;
                        if (difference <= 0) {
                            pat.letteringData.select = true;
                            pat.letteringData.amountSigned = patAmountSigned;
                            amountSigned += patAmountSigned;
                            if (difference === 0) {
                                break;
                            }
                        } else {
                            pat.letteringData.select = true;
                            pat.letteringData.amountSigned = patAmountSigned - difference;
                        }
                    }
                }
            }
        }
        return letteringSelected;
    }

    isLetteringSelected(item) {
        return !!this.letteringSelected.find((ls) => ls.index === item.index);
    }

    get partialLettering() {
        if (this.isIncomingOutgoingPayment) return false;
        if (!this.isSelectionOkForLetteringWithDelta) return false;
        // let negativeAmountFound:boolean = false
        // let positiveAmountFound:boolean = false
        let positiveAmount = 0.0;
        let negativeAmount = 0.0;
        for (const at of this.letteringSelected) {
            if (!at.letteringData.select) {
                continue;
            }
            const amountSigned = at.debit - at.credit;
            if (amountSigned < 0) {
                negativeAmount += amountSigned;
            }
            if (amountSigned > 0) {
                positiveAmount += amountSigned;
            }
        }
        return (
            !isAccountingZero(negativeAmount + positiveAmount) &&
            !isAccountingZero(negativeAmount) &&
            !isAccountingZero(positiveAmount)
        );
    }

    get leterringSelectedTotalAmount() {
        let amount = 0.0;
        for (const at of this.letteringSelected) {
            // if (at.letteringData.select) {
            amount += at.debit - at.credit;
            // }
        }

        return amount;
    }

    get isSelectionOkForLettering() {
        // if (this.accountableAccountInfo.bnc) {
        //     return false
        // }
        if (this.letteringSelected.length <= 1) {
            return false;
        }
        if (isAccountingZero(this.leterringSelectedTotalAmount)) {
            return true;
        }
        return false;
    }

    get isSelectionOkForLetteringWithDelta() {
        // if (this.accountableAccountInfo.bnc) {
        //     return false
        // }
        if (this.letteringSelected.length <= 1) {
            return false;
        }
        if (this.isSelectionOkForLettering) {
            return false;
        }

        if (Math.abs(this.leterringSelectedTotalAmount) < this.authorizedLetteringDeltaAmount) {
            return true;
        }
        return false;
    }

    get massLetteringAllowed() {
        if (this.accountableAccountInfo.bnc) {
            return false;
        }
        const candidates = this.accountingTransactions.filter((at) => at.reconciliationToValidate);
        if (candidates.length) {
            return true;
        }
        return false;
    }

    get isSelectionOkForBNCLettering() {
        if (!this.isIncomingOutgoingPayment) {
            return false;
        }
        if (!this.accountableAccountInfo.bnc) {
            return false;
        }
        if (this.letteringSelected.length != 2) {
            return false;
        }
        if (!isAccountingZero(this.leterringSelectedTotalAmount)) {
            return false;
        }
        let doc, bt;
        for (const at of this.letteringSelected) {
            if (at.object?.type === "document") {
                doc = true;
            } else if (at.object?.type === "bankTransaction") {
                bt = true;
            }
        }
        if (!doc || !bt) {
            return false;
        }
        return true;
    }

    addLetteringDelta: boolean = true;

    get createLetteringTitle() {
        if (this.isIncomingOutgoingPayment) {
            return "Rapprochement";
        }
        if (this.isSelectionOkForLettering) {
            return "Lettrage";
        }
        if (this.delta && !this.addLetteringDelta) {
            return `Lettrage Partiel`;
        }
        return "Lettrage avec écart";
    }

    get createLetteringAnswer() {
        if (this.isIncomingOutgoingPayment) {
            return "Êtes-vous sûr(e) de vouloir rapprocher ce flux bancaire et cette facture";
        }
        if (this.isSelectionOkForLettering) {
            return "Êtes-vous sûr(e) de vouloir lettrer ces éléments ?";
        }
        if (this.delta && !this.addLetteringDelta) {
            return `Êtes-vous sûr(e) de vouloir lettrer ces éléments ? Attention : un lettrage partiel sera effectué !`;
        }
        return `Êtes-vous sûr(e) de vouloir lettrer ces éléments avec un écart de ${this.newCommonFormatCurrency(
            this.leterringSelectedTotalAmount,
            undefined,
        )} ?`;
    }

    setShowLetteringDialog(addLetteringDelta) {
        if (this.isSelectionOkForLettering || this.isSelectionOkForLetteringWithDelta) {
            if (this.isSelectionOkForLettering) {
                this.delta = null;
            } else {
                this.addLetteringDelta = addLetteringDelta;
                this.delta = {
                    accountableAccount: {
                        name: this.leterringSelectedTotalAmount > 0 ? "658000" : "758000",
                    },
                    wording: "Ecart de règlement " + this.letteringDeltaWording,
                    user: null,
                    bankAccount: null,
                    thirdPartyCompany: null,
                };
            }
            this.letteringLoading = false;
            this.letteringDialog = true;
        }
    }

    get letteringDeltaWording() {
        if (this.accountableAccountInfo.displayName) {
            return this.accountableAccountInfo.displayName;
        }
        return this.accountableAccountInfo.name + " - " + this.accountableAccountInfo.description;
    }

    disletteringDialog: boolean = false;

    get isSelectionOKForDeleteLettering() {
        if (!this.selectedAccountingTransactions.length) {
            return false;
        }
        // to not deletter a line on a closing period
        const reconciliationIds = [
            ...new Set(
                this.selectedAccountingTransactions.map(
                    (transaction) => transaction.reconciliationId,
                ),
            ),
        ];
        if (reconciliationIds) {
            const allTransactionsConcerned = this.accountingTransactions.filter((transaction) =>
                reconciliationIds.includes(transaction.reconciliationId),
            );
            if (allTransactionsConcerned) {
                for (const t of allTransactionsConcerned) {
                    if (
                        isInsideAccountingClosing(this.$store, t.date) ||
                        isInsideClosedAccountingPeriod(this.$store, t.date)
                    ) {
                        return false;
                    }
                }
            }
        }
        return this.selectedAccountingTransactions.every((at) => at.lettering);
    }

    setShowDisletteringDialog() {
        if (this.isSelectionOKForDeleteLettering) {
            this.disletteringDialog = true;
        }
    }

    async deleteLetterings() {
        let deletedLetteting = {};
        for (const at of this.selectedAccountingTransactions) {
            // debugger
            if (deletedLetteting[at.reconciliationId]) {
                continue;
            }
            await this.deleteLettering(at.reconciliationId);
            deletedLetteting[at.reconciliationId] = true;
        }
        this.disletteringDialog = false;
        this.refresh();
    }

    setDeltaAccountableAccount(data) {
        // debugger
        this.delta.accountableAccount = data.accountableAccount;
        if (this.delta.user) {
            this.delta.user = null;
        }
        if (this.delta.bankAccount) {
            this.delta.bankAccount = null;
        }
        if (this.delta.thirdPartyCompany) {
            this.delta.thirdPartyCompany = null;
        }
        if (data.thirdParty) {
            switch (data.thirdParty.type) {
                case "company":
                    this.delta.thirdPartyCompany = data.thirdParty;
                    delete this.delta.thirdPartyCompany.type;
                    break;
                case "user":
                    this.delta.user = data.thirdParty;
                    delete this.delta.user.type;
                    break;
                case "bankAccount":
                    this.delta.bankAccount = data.thirdParty;
                    delete this.delta.bankAccount.type;
                    break;
            }
        }
    }

    async createLettering() {
        //
        // Compta de trésorerie
        //
        if (
            this.selectedCompany.profile?.accountingType === "INCOMING_OUTGOING_PAYMENT" &&
            this.accountableAccountInfo.bnc
        ) {
            this.letteringLoading = true;

            let documentId, bankTransactionId, documentAccountingLineId, btAccountingLineId;

            for (const at of this.letteringSelected) {
                if (at.object?.type === "document") {
                    documentId = at.object.id;
                    documentAccountingLineId = at.accountingLineId;
                } else if (at.object?.type === "bankTransaction") {
                    bankTransactionId = at.object.id;
                    btAccountingLineId = at.accountingLineId;
                }
            }
            if (!bankTransactionId || !documentId || !documentAccountingLineId) {
                return false;
            }

            await this.$apollo.mutate({
                mutation: LINK_BANKTRANSACTION_AND_DOCUMENT,
                variables: {
                    documentId,
                    bankTransactionId,
                    btAccountingLineId,
                    documentAccountingLineId,
                    isIncomingOutgoingPayment: this.isIncomingOutgoingPayment,
                },
            });
            this.letteringLoading = false;
            this.refresh();
        }
        // compta d'engagement
        else {
            if (this.letteringSelected.length > 1) {
                this.letteringLoading = true;
                const accountingLines = [];
                if (!this.addLetteringDelta) {
                    for (const s of this.letteringSelected) {
                        if (s.accountingLineId) {
                            if (s.letteringData) {
                                if (s.letteringData.select) {
                                    accountingLines.push({
                                        id: s.accountingLineId,
                                        amountSigned: s.letteringData.amountSigned,
                                    });
                                }
                            } else {
                                debugger;
                                return;
                            }
                        } else {
                            debugger;
                            return;
                        }
                    }
                } else {
                    for (const s of this.letteringSelected) {
                        accountingLines.push({
                            id: s.accountingLineId,
                            amountSigned: s.debit - s.credit,
                        });
                    }
                }
                await this.$apollo.mutate({
                    mutation: CREATE_LETTERING,
                    variables: {
                        companyId: this.companyId,
                        accountingLines: accountingLines,
                        delta: this.addLetteringDelta ? this.delta : null,
                    },
                });

                this.refresh();
                this.letteringLoading = false;
            }
        }

        this.letteringDialog = false;
    }

    get candidateToTerminate() {
        const candidateToTerminate = [];
        if (!this.letteringSelected.length) {
            return candidateToTerminate;
        }
        for (const at of this.accountingTransactions) {
            if (!at.lettering && !this.isLetteringSelected(at)) {
                if (isAccountingZero(at.debit - at.credit + this.leterringSelectedTotalAmount)) {
                    candidateToTerminate.push(at);
                }
            }
        }
        return candidateToTerminate;
    }

    deleteLetteringLoading = false;
    deleteLetteringDialog = false;
    toDeleteReconciliationId = "";

    opendDeleteDialog(accountingTransaction) {
        if (accountingTransaction.reconciliationId) {
            this.deleteLetteringDialog = true;
            this.toDeleteReconciliationId = accountingTransaction.reconciliationId;
        } else {
            this.deleteLetteringDialog = false;
            this.toDeleteReconciliationId = "";
        }
    }

    async deleteLettering(reconciliationId = "") {
        if (this.toDeleteReconciliationId || reconciliationId) {
            this.deleteLetteringLoading = true;
            await this.$apollo.mutate({
                mutation: DELETE_RECONCILIATION,
                variables: {
                    reconciliationId: reconciliationId || this.toDeleteReconciliationId,
                },
            });
            if (this.toDeleteReconciliationId) {
                this.refresh();
            }
            this.deleteLetteringLoading = false;
        }
        this.deleteLetteringDialog = false;
    }

    closeAccountableAccount() {}

    //
    // callback management
    //
    refreshNeeded: boolean = false;

    onReconciliationUpdated() {
        this.refreshNeeded = true;
        // this.showAccountingTransactionDialog = false
        // this.showReconciliation = false
        // this.$emit("refresh")
    }

    onDocumentDeleted() {
        debugger;
        this.showDocument = false;
        this.showAccountingTransactionDialog = false;
        this.refreshFather();
    }

    onDocumentUpdated() {
        this.refreshNeeded = true;
        // this.showDocument = false
        // this.showAccountingTransactionDialog = false
        // this.$emit("refresh")
    }

    closeDocRecDialog() {
        if (this.refreshNeeded) {
            this.refreshNeeded = false;
            this.refreshFather();
        }
        this.showDocument = false;
        this.showReconciliation = false;
        this.showAccountingTransactionDialog = false;
    }

    //
    // create bankTransaction message
    //
    showCreateBankTransactionMessageDialog = false;
    // selectedBankTransactionsForMessage=[]

    // computeSelectedBankTransactionsForMessage() {
    //     this.selectedBankTransactionsForMessage = []
    //     for (const accountingTransaction of this.workingAccountingTransactions) {
    //         if (!accountingTransaction.selected) {
    //             continue
    //         }

    //         if (accountingTransaction.object.type === "bankTransaction" &&
    //             (!accountingTransaction.chat || (accountingTransaction.chat.lastMessage.sender.company && !accountingTransaction.chat.lastMessage.sender.company.accountingFirm))
    //         ) {
    //             this.selectedBankTransactionsForMessage.push(accountingTransaction.object.id)
    //         }
    //     }
    // }

    get selectedBankTransactionsForMessage() {
        const selectedBankTransactionsForMessage = [];
        for (const selectedAccountingTransaction of this.selectedAccountingTransactions) {
            if (
                selectedAccountingTransaction.object.type === "bankTransaction" &&
                (!selectedAccountingTransaction.chat ||
                    (selectedAccountingTransaction.chat.lastMessage.sender.company &&
                        !selectedAccountingTransaction.chat.lastMessage.sender.company
                            .accountingFirm))
            ) {
                selectedBankTransactionsForMessage.push(selectedAccountingTransaction.object.id);
            }
        }
        return selectedBankTransactionsForMessage;
    }

    get candidateBankTransactionsForMessage() {
        let btIds = [];
        for (const accountingTransaction of this.workingAccountingTransactions) {
            if (
                accountingTransaction.object.type === "bankTransaction" &&
                (!accountingTransaction.chat ||
                    !accountingTransaction.chat.lastMessage.sender.company.accountingFirm)
            ) {
                btIds.push(accountingTransaction.object.id);
            }
        }
        return btIds;
    }

    get containsManualAccountingLines() {
        for (const at of this.accountingTransactions) {
            if (at.object && at.object.accountingLinesLocked) {
                return true;
            }
        }
    }

    get containsAutomaticAccountingLines() {
        for (const at of this.fullSelectedAccountingTransactions) {
            if (at.object && !at.object.accountingLinesLocked) {
                return true;
            }
        }
        return false;
    }

    get where471() {
        if (this.isAccountingUser) {
            return {};
        }
        return {
            includeRootAAs: ["401000", "411000", "421000", "425000", "455000", "108000"],
        };
    }

    get accountableAccountReplacementRule(): any {
        if (!this.accountableAccountInfo.name) {
            return null;
        }
        if (this.fullSelectedAccountingTransactions.length) {
            // let onlyMO = true
            // for (const at of this.fullSelectedAccountingTransactions) {
            //     if (!at.object || !at.object.accountingLinesLocked) {
            //         onlyMO = false
            //         break
            //     }
            // }
            // if (onlyMO) {
            const rule = {
                where: {},
            };
            // this.finaliseRule(rule)
            return rule;
            // }
        }
        const replacementRules: any = [
            {
                where: {
                    includeRootAAs: ["1"],
                },
            },
            {
                inWhere: {
                    name_starts_with: "2",
                },
                where: {
                    includeRootAAs: ["2", "6"],
                },
            },
            {
                inWhere: {
                    name_starts_with: "3",
                },
                where: {
                    includeRootAAs: ["3", "6"],
                },
            },
            {
                where: {
                    includeRootAAs: ["43"],
                },
            },
            // {
            //     where: {
            //         includeRootAAs: ["44"]
            //     }
            // },
            {
                // fromAccountingImportOnly: true,
                inWhere: {
                    name_starts_with: "455100",
                },
                where: {
                    includeRootAAs: ["455000"],
                },
            },
            {
                where: {
                    includeRootAAs: ["467"],
                },
            },
            {
                inWhere: {
                    name_starts_with: "471",
                },
                where: this.where471,
            },
            // {
            //     where: {
            //         includeRootAAs: ["46"]
            //     }
            // },
            {
                where: {
                    includeRootAAs: ["48"],
                },
            },
            {
                where: {
                    includeRootAAs: ["49"],
                },
            },
            {
                where: {
                    includeRootAAs: ["50"],
                },
            },
            {
                where: {
                    includeRootAAs: ["5111"],
                },
            },
            {
                where: {
                    includeRootAAs: ["5801"],
                },
            },
            {
                where: {
                    includeRootAAs: ["59"],
                },
            },
            {
                inWhere: {
                    name_starts_with: "6",
                },
                where: {
                    includeRootAAs: ["2", "3", "6"],
                },
            },
            {
                fromAccountingImportOnly: true,
                inWhere: {
                    name: "701",
                },
                where: {
                    includeRootAAs: ["701"],
                },
            },
            {
                fromAccountingImportOnly: true,
                inWhere: {
                    name: "702",
                },
                where: {
                    includeRootAAs: ["702"],
                },
            },
            {
                fromAccountingImportOnly: true,
                inWhere: {
                    name: "703",
                },
                where: {
                    includeRootAAs: ["703"],
                },
            },
            {
                fromAccountingImportOnly: true,
                inWhere: {
                    name: "704",
                },
                where: {
                    includeRootAAs: ["704"],
                },
            },
            {
                fromAccountingImportOnly: true,
                inWhere: {
                    name: "705",
                },
                where: {
                    includeRootAAs: ["705"],
                },
            },
            {
                fromAccountingImportOnly: true,
                inWhere: {
                    name: "706",
                },
                where: {
                    includeRootAAs: ["706"],
                },
            },
            {
                fromAccountingImportOnly: true,
                inWhere: {
                    name: "707",
                },
                where: {
                    includeRootAAs: ["707"],
                },
            },
            {
                fromAccountingImportOnly: true,
                inWhere: {
                    name: "708",
                },
                where: {
                    includeRootAAs: ["708"],
                },
            },
            {
                fromAccountingImportOnly: true,
                inWhere: {
                    name: "709",
                },
                where: {
                    includeRootAAs: ["709"],
                },
            },
            {
                fromAccountingImportOnly: true,
                inWhere: {
                    name_starts_with: "70",
                },
                accountableAccountType: "Sales",
            },
        ];
        for (const rule of replacementRules) {
            if (rule.inWhere) {
                if (rule.inWhere.name) {
                    if (this.accountableAccountInfo.name === rule.inWhere.name) {
                        // this.finaliseRule(rule)
                        return rule;
                    }
                } else if (rule.inWhere.name_starts_with) {
                    if (
                        this.accountableAccountInfo.name.startsWith(rule.inWhere.name_starts_with)
                    ) {
                        // this.finaliseRule(rule)
                        return rule;
                    }
                } else {
                    debugger;
                }
                continue;
            } else if (rule.where.includeRootAAs?.length === 1) {
                if (this.accountableAccountInfo.name.startsWith(rule.where.includeRootAAs[0])) {
                    // this.finaliseRule(rule)
                    return rule;
                }
            } else {
                debugger;
            }
        }
        return null;
    }

    // finaliseRule(rule) {
    // if (rule.where) {
    //     const OR = [
    //         {company: null},
    //         {company: {id: this.companyId}}
    //     ]
    //     if (rule.where.AND) {
    //         rule.where.AND.push({
    //             OR
    //         })
    //     } else if (!rule.OR) {
    //         rule.where.OR = OR
    //     } else {
    //         debugger;
    //     }
    // }
    // }
    //
    // prev next
    //

    previousDisabled() {
        return this.selectedAccountingTransactionIndex <= 0;
    }

    previous() {
        if (this.selectedAccountingTransactionIndex > 0) {
            this.openAccountingTransaction(
                this.accountingTransactions[this.selectedAccountingTransactionIndex - 1],
                undefined,
            );
        }
    }

    nextDisabled() {
        return this.selectedAccountingTransactionIndex + 1 >= this.accountingTransactions.length;
    }

    next() {
        if (this.selectedAccountingTransactionIndex + 1 < this.accountingTransactions.length) {
            this.openAccountingTransaction(
                this.accountingTransactions[this.selectedAccountingTransactionIndex + 1],
                undefined,
            );
        }
    }

    get addCheckBoxColumn() {
        return false;
    }

    get lastFirstColumnColspan() {
        let colspan = 2;
        if (this.addCheckBoxColumn) {
            colspan++;
        }
        if (this.isIncomingOutgoingPayment) {
            colspan++;
        }
        if (this.enableLettering) {
            colspan += 2;
        }
        return colspan;
    }

    //
    //
    //
    accountableAccount = null;
    thirdPartyCompany = { id: "", name: "", siret: "" };
    user = { id: "", firstname: "", lastname: "" };
    bankAccount = { id: "", name: "", startAuthorizedDate: "" };
    validLoading: boolean = false;
    switchResultDialog: boolean = false;
    switchResult: any = null;

    validAA(data) {
        this.accountableAccount = data.accountableAccount;
        if (data.thirdParty) {
            if (data.thirdParty.type === "company") {
                this.thirdPartyCompany = data.thirdParty;
            } else if (data.thirdParty.type === "user") {
                this.user = data.thirdParty;
            } else if (data.thirdParty.type === "bank" || data.thirdParty.type === "bankAccount") {
                this.bankAccount = data.thirdParty;
            }
        }
        this.valid();
    }

    async valid() {
        this.validLoading = true;

        if (
            this.filteredSelectedAccountingTransactionsId.length ||
            this.filteredSelectedBankTransaction.length
        ) {
            let thirdPartyCompanyId = this.thirdPartyCompany
                ? this.thirdPartyCompany.id
                : undefined;
            if (this.thirdPartyCompany.name && !this.thirdPartyCompany.id) {
                thirdPartyCompanyId = await createCompany(this.$apollo, this.thirdPartyCompany);
            }
            if (this.filteredSelectedAccountingTransactionsId.length) {
                if (
                    (this.accountableAccount && this.accountableAccount.id) ||
                    thirdPartyCompanyId ||
                    (this.user && this.user.id) ||
                    (this.bankAccount && this.bankAccount.id)
                ) {
                    let filteredSelectedAuthorizedATId =
                        this.filteredSelectedAccountingTransactionsId;
                    if (this.bankAccount && this.bankAccount.startAuthorizedDate) {
                        const authorizedDate = this.bankAccount.startAuthorizedDate;
                        const filteredTransactions = this.selectedAccountingTransactions.filter(
                            (at) => !moment(at.date).isSameOrBefore(authorizedDate),
                        );
                        let filteredTransactionsId = [];
                        if (filteredTransactions.length) {
                            filteredTransactionsId = filteredTransactions.map(
                                (at) => at.accountingLineId,
                            );
                        }
                        if (
                            filteredTransactionsId.length !== filteredSelectedAuthorizedATId.length
                        ) {
                            filteredSelectedAuthorizedATId = filteredTransactionsId;
                            this.alertNonAuthorizedDatesDialog = true;
                        }
                    }
                    const result = await this.$apollo.mutate({
                        mutation: SWITCH_ACCOUNTABLE_ACCOUNT,
                        variables: {
                            accountingLines: filteredSelectedAuthorizedATId,
                            accountableAccountId: this.accountableAccount
                                ? this.accountableAccount.id
                                : null,
                            thirdPartyCompanyId,
                            bankAccountId:
                                this.bankAccount && this.bankAccount.id
                                    ? this.bankAccount.id
                                    : undefined,
                            userId: this.user && this.user.id ? this.user.id : undefined,
                        },
                    });
                    if (
                        result.data &&
                        result.data.switchAccountableAccount &&
                        result.data.switchAccountableAccount.result
                    ) {
                        const output = result.data.switchAccountableAccount.result;
                        if (
                            output.excludedAccountingLines &&
                            output.excludedAccountingLines.length
                        ) {
                            this.switchResultDialog = true;
                            this.switchResult = output;
                        }
                        if (
                            !this.alertNonAuthorizedDatesDialog &&
                            (!output.accountingLines || output.accountingLines.length)
                        ) {
                            this.refreshFather();
                        }
                    }
                }
            }
            //
            // 471 without accountingLineId only
            //
            if (this.filteredSelectedBankTransaction.length) {
                const data = {
                    accountableAccount: this.accountableAccount,
                    thirdParty: {
                        type: undefined,
                        id: undefined,
                    },
                };
                if (thirdPartyCompanyId) {
                    data.thirdParty.type = "company";
                    data.thirdParty.id = thirdPartyCompanyId;
                } else if (this.bankAccount && this.bankAccount.id) {
                    data.thirdParty.type = "bankAccount";
                    data.thirdParty.id = this.bankAccount.id;
                } else if (this.user && this.user.id) {
                    data.thirdParty.type = "user";
                    data.thirdParty.id = this.user.id;
                }
                await updateBankTransactionAccountableAccount(
                    this.$apollo,
                    this.$store,
                    this.companyId,
                    this.filteredSelectedBankTransaction,
                    data,
                );
                this.refreshFather();
            }
        }
        this.validLoading = false;
    }

    async validateReconciliation(reconciliationId) {
        await this.$apollo.mutate({
            mutation: VALIDATE_RECONCILIATION,
            variables: {
                id: reconciliationId,
            },
        });

        for (const at of this.accountingTransactions) {
            if (at.reconciliationId === reconciliationId) {
                at.reconciliationToValidate = false;
            }
        }
    }

    async validateAllReconciliations() {
        for (const at of this.accountingTransactions) {
            if (at.reconciliationToValidate && at.reconciliationId) {
                await this.$apollo.mutate({
                    mutation: VALIDATE_RECONCILIATION,
                    variables: {
                        id: at.reconciliationId,
                    },
                });
                at.reconciliationToValidate = false;
            }
        }
        this.refresh();
    }

    async copyToClipboard() {
        const accountingTransactions = this.fullSelectedAccountingTransactions?.length
            ? this.fullSelectedAccountingTransactions
            : this.accountingTransactions;
        if (!accountingTransactions?.length) {
            return;
        }

        let text = "";
        text += "Journal";
        text += "\t";
        text += "Date";
        text += "\t";
        text += "Compte";
        text += "\t";
        if (this.accountableAccountInfo.thirdPartyCompanyName) {
            text += "Client|Fournisseur";
            text += "\t";
        } else if (this.accountableAccountInfo.userId) {
            text += "Utilisateur";
            text += "\t";
        } else if (this.accountableAccountInfo.bankAccountName) {
            text += "Banque";
            text += "\t";
        } else {
            text += "Description";
            text += "\t";
        }
        if (this.enableLettering) {
            text += "Lettrage";
            text += "\t";
        }
        text += "Libellé";
        text += "\t";
        text += "Référence";
        text += "\t";
        text += "Débit";
        text += "\t";
        text += "Crédit";
        text += "\t";
        text += "Solde";
        text += "\n";

        for (const at of accountingTransactions) {
            text += this.getItemLog(at);
            text += "\t";
            text += moment(at.date).format("DD/MM/YYYY");
            text += "\t";
            text += this.accountableAccountInfo.name;
            text += "\t";
            text += getXMLString(this.accountableAccountInfo.description);
            text += "\t";
            // if (this.accountableAccountInfo.thirdPartyCompanyName) {
            //     text +=  this.accountableAccountInfo.thirdPartyCompanyName
            //     text +=  "\t"
            // }
            // if (this.accountableAccountInfo.userId) {
            //     text +=  this.accountableAccountInfo.userId
            //     text +=  "\t"
            // }
            // if (this.accountableAccountInfo.bankAccountName) {
            //     text +=  this.accountableAccountInfo.bankAccountName
            //     text +=  "\t"
            // }
            if (this.enableLettering) {
                text += at.lettering || "";
                text += "\t";
            }
            text += getXMLString(at.wording || "");
            text += "\t";
            text += getXMLString(at.invoiceNumber || "");
            text += "\t";
            text += mathFix(at.debit).toString().replace(".", ",");
            text += "\t";
            text += mathFix(at.credit).toString().replace(".", ",");
            text += "\t";
            text += mathFix(at.balance).toString().replace(".", ",");
            text += "\n";
        }
        // console.log(text)
        await navigator.clipboard.writeText(text);
    }
    // beforeMount() {
    //     this.addEventListener()
    // }
    // beforeDestroy() {
    //     this.removeEventListener()
    // }

    // removeEventListener() {
    //     document.removeEventListener("keydown", this.onKeyDown)
    // }

    // addEventListener() {
    //     document.addEventListener("keydown", this.onKeyDown)
    // }

    async onKeyDown(ev) {
        const event = ev || window.event; // Event object 'ev'
        if (event) {
            const key = event.which || event.keyCode; // Detecting keyCode
            if (key) {
                // console.log("keydown= key= "+ key);
                // console.log("keydown= event.ctrlKey= "+ event.ctrlKey);

                // Detecting Ctrl
                var ctrl = event.ctrlKey ? event.ctrlKey : key === 17 ? true : false;
                // console.log("keydown= event.ctrl= ", ctrl);
                if (key === 67 && ctrl) {
                    await this.copyToClipboard();
                }
            }
        }
    }

    get selectionContainsATInAccountingClosing() {
        for (const at of this.selectedAccountingTransactions) {
            if (
                isInsideAccountingClosing(this.$store, at.date) ||
                isInsideClosedAccountingPeriod(this.$store, at.date)
            ) {
                return true;
            }
        }
        return false;
    }

    get enableModification() {
        return !this.selectionContainsATInAccountingClosing;
    }

    get labelTextColor() {
        return colors.grey.darken2;
    }
}

type AccountingTransaction = {
    log: string;
    number: number;
    date: string;
    wording: string;
    debit: number;
    credit: number;
    balance: number;
    object: {
        type: string;
        id: string;
        fromDocumentId: string | null;
        accountingItemImport: string | null;
        accountingLinesLocked: number;
        original: string | null;
        lastSentMail: string | null;
    };
    thirdPartyCompanyId: string;
    thirdPartyCompanyName: string;
    fromCarryForward: boolean;
    vatDeclarationId: string | null;
    lettering: string;
    accountingLineId: string;
    index: number;
    invoiceNumber: string;
    reconciliationToValidate: boolean;
    reconciliationId: string;
    chat: any;
};
